const AlertIcon = ({ fill = "#343741" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M8.54975 9.50248L8.9005 5.99504C8.95377 5.46228 8.53541 5 8 5C7.46459 5 7.04623 5.46229 7.0995 5.99504L7.45025 9.50248C7.47849 9.78492 7.71616 10 8 10C8.28384 10 8.52151 9.78492 8.54975 9.50248Z"
        fill={fill}
      />
      <path
        d="M9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.86378 1.49613C8.68457 1.18891 8.35567 1 8 1C7.64433 1 7.31543 1.18891 7.13622 1.49613L0.136221 13.4961C-0.0441976 13.8054 -0.0454804 14.1876 0.132858 14.4981C0.311196 14.8086 0.641935 15 1 15H15C15.3581 15 15.6888 14.8086 15.8671 14.4981C16.0455 14.1876 16.0442 13.8054 15.8638 13.4961L8.86378 1.49613ZM1 14L8 2L15 14H1Z"
        fill={fill}
      />
    </svg>
  );
};

export default AlertIcon;
